import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { TargetModel } from '@/libs/Api';
import { TargetsDataService } from '@/libs/targets/targets-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const targetsStore = registerCrudStore<TargetModel, TargetModel>(BusinessModule.Target, new TargetsDataService());
